/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon32Regular = forwardRef('ArrowAUpRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10.5 5a1 1 0 0 0 0 2h13c.028 0 .056 0 .084.002L5.793 24.792a1 1 0 1 0 1.414 1.415l17.79-17.79c.002.027.003.055.003.083v13a1 1 0 1 0 2 0v-13A3.5 3.5 0 0 0 23.5 5h-13Z" })));
});
